import {
  IconButton,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { format } from "date-fns";
import {
  HiCog,
  HiOutlineDotsVertical,
  HiOutlineTrash,
  HiPencil,
} from "react-icons/hi";
import { Link as RouterLink, useNavigate } from "react-router-dom";

import { Cellular } from "src/common/icons/Cellular";
import { SortableTh } from "src/common/SortableTh";
import { Intercom } from "src/common/types";
import { useFlags } from "src/common/useFlags";

type Props = {
  onDeleteIntercom: (intercom: Intercom) => void;
  onEditIntercom: (intercom: Intercom) => void;
  intercoms: Intercom[];
};
export const IntercomsTable = ({
  onDeleteIntercom,
  onEditIntercom,
  intercoms,
}: Props) => {
  const { gen4AdminPortal } = useFlags();
  const navigate = useNavigate();
  return (
    <Table variant="simple">
      <Thead>
        <Tr>
          <SortableTh sortKey="serialNumber">Serial Number</SortableTh>
          <SortableTh sortKey="intercomModel">Intercom Model</SortableTh>
          <SortableTh sortKey="dealerOrganization">
            Dealer Organization
          </SortableTh>
          <SortableTh sortKey="propertyOrganization">
            Property Organization
          </SortableTh>
          <Th>Date Activated</Th>
          <Th>Date Deactivated</Th>
          <Th></Th>
        </Tr>
      </Thead>
      <Tbody>
        {intercoms.map((intercom) => (
          <Tr key={intercom.intercomId}>
            <Td>
              <Link
                as={RouterLink}
                to={`/product-units/intercoms/${intercom.intercomId}/details`}
              >
                {intercom.serialNumber}
              </Link>
            </Td>
            <Td>
              {intercom.intercomModel} - {intercom.productSku}
            </Td>
            <Td>{intercom.dealerOrganization ?? "-"}</Td>
            <Td>{intercom.propertyOrganization ?? "-"}</Td>
            <Td>
              {intercom.activatedAt
                ? format(new Date(intercom.activatedAt), "P")
                : "-"}
            </Td>
            <Td>
              {intercom.deactivatedAt
                ? format(new Date(intercom.deactivatedAt), "P")
                : "-"}
            </Td>
            <Td>
              <Menu>
                <MenuButton
                  as={IconButton}
                  aria-label="Actions"
                  icon={<HiOutlineDotsVertical />}
                  variant="clear"
                >
                  Actions
                </MenuButton>
                <MenuList>
                  <MenuItem
                    justifyContent="space-between"
                    onClick={() => onEditIntercom(intercom)}
                  >
                    Edit Intercom
                    <HiPencil />
                  </MenuItem>
                  {intercom.cellKitId ? (
                    <MenuItem
                      justifyContent="space-between"
                      onClick={() => {
                        navigate(
                          `/product-units/cell-kits/${intercom.cellKitId}/details`
                        );
                      }}
                    >
                      Access Cell Kit Details
                      <Cellular />
                    </MenuItem>
                  ) : null}
                  <MenuItem
                    isDisabled={!!intercom.lastActivatedAt}
                    justifyContent="space-between"
                    onClick={() => onDeleteIntercom(intercom)}
                  >
                    Remove Intercom
                    <HiOutlineTrash />
                  </MenuItem>
                  {gen4AdminPortal ? (
                    <MenuItem
                      justifyContent="space-between"
                      onClick={() => {
                        navigate(
                          `/product-units/intercoms/${intercom.intercomId}/support`
                        );
                      }}
                    >
                      Support Tools
                      <HiCog />
                    </MenuItem>
                  ) : null}
                </MenuList>
              </Menu>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};
